import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom/cjs/react-router-dom';
import Homepage from '../pages/Homepage';
import Aboutuspage from '../pages/Aboutuspage';
import Recentprojectdetailspage from '../pages/Recentprojectdetailspage';
import Contactpage from '../pages/Contactpage';
import Photogallery from '../pages/Photogallery';
import Eventdetailspage from '../pages/Eventdetailspage';
import Eventpage from '../pages/Eventpage';
import Teampage from '../pages/Teampage';
import Videospage from '../pages/Videospage';
import Projectpage from '../pages/Projectpage';
import Donatepage from '../pages/Donatepage';
import AllReportsPage from '../components/AnnualReports/AllReportsPage';
import ThankYouPage from '../pages/ThankYouPage';

class AppRouter extends Component {
    render() {
        return (
            <div>
                <Switch>
                    <Route exact path='/'>
                        <Homepage/>
                    </Route>

                    {/* <Route exact path='/about'>
                        <Aboutuspage/>
                    </Route> */}

                    <Route exact path='/about' component={Aboutuspage} />

                    {/* <Route exact path='/projectdetails'>
                        <Recentprojectdetailspage/>
                    </Route> */}
                    
                    <Route exact path="/projectdetails/:projectId/:projectName" component={Recentprojectdetailspage} />

                    {/* <Route exact path='/contact'>
                        <Contactpage/>
                    </Route> */}
                    <Route exact path="/contact" component={Contactpage} />

                    <Route exact path='/allgallery'>
                        <Photogallery/>  { /* forgot to write photogallerypage*/}
                    </Route>
                    
                    <Route exact path='/donate'>
                        <Donatepage/>
                    </Route>
                    
                    <Route exact path='/thank-you' component={ThankYouPage} />
                    
                    {/* <Route exact path='/eventdetails/:Eventid'>
                        <Eventdetailspage/>
                    </Route> */}

                    <Route exact path="/eventdetails/:Eventid/:eventName" component={Eventdetailspage} />

                    <Route exact path='/allevents'>
                        <Eventpage/>
                    </Route>
                    

                    <Route exact path='/allprojects'>
                        <Projectpage/>
                    </Route>

                    <Route exact path='/allteam'>
                        <Teampage/>
                    </Route>

                    <Route exact path='/allvideogallery'>
                        <Videospage/>
                    </Route>

                    <Route exact path='/annual-reports'>
                        <AllReportsPage/>
                    </Route>

                </Switch>
                
            </div>
        );
    }
}

export default AppRouter;